import React   from 'react'; 
import   'scss/components/page-components/AuthenticationLayout.scss';

const AuthenticationLayout = (props) => {
    return  (
    <div className="L_AuthenticationLayout" >
           { props.children }
    </div> );
}

export default AuthenticationLayout;
   